// Async boundary for Module Federation shared dependency negotiation
import('./bootstrap');
